import { render, staticRenderFns } from "./letter.vue?vue&type=template&id=51639c58&scoped=true"
import script from "./letter.vue?vue&type=script&lang=js"
export * from "./letter.vue?vue&type=script&lang=js"
import style0 from "./letter.vue?vue&type=style&index=0&id=51639c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51639c58",
  null
  
)

export default component.exports